<div class="content-analysis-artifact">
  @if (showStats && stats) {
    <div class="stats-summary">
      <div class="total-observations">{{ stats.totalObservations }} Total Observations</div>
      <div class="stat-pills">
        <div class="stat violation" pTooltip="Violations" tooltipPosition="top">
          {{ stats.violation.total }}
        </div>
        <div class="stat compliant" pTooltip="Compliant" tooltipPosition="top">
          {{ stats.passes.total }}
        </div>
        <div class="stat inapplicable" pTooltip="Inapplicable" tooltipPosition="top">
          {{ stats.inapplicable.total }}
        </div>
      </div>
    </div>
  }

  <p-accordion class="observations-accordion" [activeIndex]="0">
    <!-- Violations Tab -->
    @if (violations && violations.length > 0) {
      <p-accordionTab>
        <ng-template pTemplate="header">
          <span class="result-header">
            <span class="header-text">Violations</span>
            <fa-icon class="violation-icon" [icon]="faTimesCircle"/>
          </span>
        </ng-template>
        <ng-template pTemplate="content">
          <div class="tab-content">
            @if (showStats && stats) {
              <div class="issue-stats">
                <div class="total">{{ stats.violation.total }} Observations</div>
                <div class="stat-pills">
                  <div class="stat critical" pTooltip="Critical" tooltipPosition="top">
                    {{ stats.violation.critical }}
                  </div>
                  <div class="stat serious" pTooltip="Serious" tooltipPosition="top">
                    {{ stats.violation.serious }}
                  </div>
                  <div class="stat moderate" pTooltip="Moderate" tooltipPosition="top">
                    {{ stats.violation.moderate }}
                  </div>
                  <div class="stat minor" pTooltip="Minor" tooltipPosition="top">
                    {{ stats.violation.minor }}
                  </div>
                </div>
              </div>
            }

            <wm-a11y-observation-list
              [observations]="violations"
              [reportData]="reportData"
              [artifact]="artifact"
              [observationType]="'violation'">
            </wm-a11y-observation-list>
          </div>
        </ng-template>
      </p-accordionTab>
    }

    <!-- Passes Tab -->
    @if (passes && passes.length > 0) {
      <p-accordionTab>
        <ng-template pTemplate="header">
          <span class="result-header">
            <span class="header-text">Compliant</span>
            <fa-icon class="compliant-icon" [icon]="faCheckCircle"/>
          </span>
        </ng-template>
        <ng-template pTemplate="content">
          <div class="tab-content">
            @if (showStats && stats) {
              <div class="issue-stats">
                <div class="total">{{ stats.passes.total }} Observations</div>
              </div>
            }

            <wm-a11y-observation-list
              [observations]="passes"
              [reportData]="reportData"
              [artifact]="artifact"
              [observationType]="'pass'">
            </wm-a11y-observation-list>
          </div>
        </ng-template>
      </p-accordionTab>
    }

    <!-- Inapplicable Tab -->
    @if (inapplicable && inapplicable.length > 0) {
      <p-accordionTab>
        <ng-template pTemplate="header">
          <span class="result-header">
            <span class="header-text">Inapplicable</span>
            <fa-icon class="inapplicable-icon" [icon]="faMinusCircle"/>
          </span>
        </ng-template>
        <ng-template pTemplate="content">
          <div class="tab-content">
            @if (showStats && stats) {
              <div class="issue-stats">
                <div class="total">{{ stats.inapplicable.total }} Observations</div>
              </div>
            }

            <p-accordion class="inapplicable-list">
              @for (item of inapplicable; track item.id || $index) {
                <p-accordionTab>
                  <ng-template pTemplate="header">
                    <div class="title">{{ item.help }}</div>
                  </ng-template>
                  <ng-template pTemplate="content">
                    <div class="inapplicable-content">
                      <div class="form-section no-infos">
                        <div class="form-section-content">
                          @if (item.tags) {
                            <div class="form-item">
                              <label class="form-label">WCAG Mapping</label>
                              <div class="wcag-mapping">
                                @for (label of item.tags; track $index) {
                                  <div class="wcag-label">{{ label }}</div>
                                }
                              </div>
                            </div>
                          }
                          @if (item.description) {
                            <div class="form-item">
                              <label class="form-label">Description</label>
                              <div class="description">{{ item.description }}</div>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </p-accordionTab>
              }
            </p-accordion>
          </div>
        </ng-template>
      </p-accordionTab>
    }
  </p-accordion>
</div>